import {hasValue} from '@famly/stat_ts-utils_has-value';

import {objectToQueryString} from './object-to-query-string';

export const buildUrlWithQueryParameters = (
    origin: string,
    queryParameters: {[k: string]: string | number | undefined | null} = {},
): string => {
    const filteredQueryParams = Object.fromEntries(
        Object.entries(queryParameters)
            .map(([key, value]) => (hasValue(value) ? ([key, value] as const) : null))
            .filter(hasValue),
    );

    const queryParamsString = objectToQueryString(filteredQueryParams);

    return `${origin}${queryParamsString ? `?${queryParamsString}` : ''}`;
};
